import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { store } from "../Stores/store";
import { LoginResponse } from "../Models/LoginResponse";
import { RSVPFormValues } from "../Models/RSVPFormValues";
import { ContactFormValues } from "../Models/ContactFormValues";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';


axios.interceptors.request.use(config => {
    const token = store.generalStore.token;
    if(token && config !== undefined) config!.headers!.Authorization = `Bearer ${token}`;
    return config;
});


axios.interceptors.response.use(async response => {
    return response;
}, (error: AxiosError) => {
    const { status } = error.response || {};

    if (status === 400) {
      toast.error("Uh oh! Something's not right with your request. Please try again later.");
    //   toast.error(data);
    } else if (status === 401 || status === 403) {
      toast.error("Unauthorised");
      store.generalStore.resetUser();
    } else if (status && status >= 500) {
      toast.error("Server error. Please try again later.");
    }

    return Promise.reject(error);
});

const responseBody = <T> (response : AxiosResponse<T>) => response;

const requests = {
    get : <T> (url: string) => axios.get<T>(url).then(responseBody),
    post : <T> (url: string, body : object) => axios.post<T>(url, body).then(responseBody),
    put : <T> (url: string, body : object) => axios.put<T>(url, body).then(responseBody),
    delete : <T> (url: string) => axios.delete<T>(url).then(responseBody),
}

const api = {
    login : (code : string) => requests.post<LoginResponse>("/api/auth/login", { 'code': code }),
    rsvp : (body : RSVPFormValues) => requests.post("/api/rsvp", body),
    contact : (body : ContactFormValues) => requests.post("/api/contact", body),
}

const agent = {
    api
}

export default agent;
